import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllTrainerData } from "../../redux/reducers/apiSlice";
import { selectAuth } from "../auth/auth.selector";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { Button, Col, Container, Row } from "react-bootstrap";
import { SearchIcon } from "../../images/icons/website-icons";
import SelectDropdownLabel from "../components-react/SelectDropdownLabel";
import { useGymFilter } from "../../hooks/useGymFilter";
import { useStatusFilter } from "../../hooks/useStatusFilter";
import TrainerEdit from "./TrainerEdit";
import Modal from "react-modal";
import "./trainer.css";
import { ExportCSVButton, getCSVData, trainerTbColumns } from "./trainer-utils";
import CommonStructured from "../common-components/CommonStructured";

const Trainers = () => {
  const dispatch = useDispatch();

  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const { loading, trainerData } = useSelector((state) => state.api);
  const { gymData, gymValue, setGymValue, handleGymChange } = useGymFilter();
  const { statuses, statusValue, handleStatusChange, setStatusValue } =
    useStatusFilter();

  const [isPage, setIsPage] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const [filters, setFilters] = useState({
    search: "",
    limit: pageLimit || 10,
    page: isPage + 1,
    gym_id: gymValue?.value || "",
    status: statusValue?.value || "",
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [initialValue, setInitialValue] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  function onCloseModalvalues() {
    setModalOpen(false);
  }

  // Fetch trainers data
  const getTrainerData = () => {
    dispatch(fetchAllTrainerData({ filters, token: userInfoData?.token }));
  };

  useEffect(() => {
    getTrainerData();
  }, [filters]);

  const onClickSearch = () => {
    setIsPage(0);
    setFilters((prevFilters) => ({
      ...prevFilters,
      search: searchValue,
    }));
  };

  // Reset all filters
  const handleReset = () => {
    setFilters({ limit: 10, page: 1, search: "", gym_id: "", status: "" });
    setSearchValue("");
    setGymValue(null);
    setStatusValue(null);
    setPageLimit(10);
  };

  // Reset pagination when gym or status filter changes
  useEffect(() => {
    setIsPage(0);
    setFilters((prevFilters) => ({
      ...prevFilters,
      gym_id: gymValue?.value || "",
      status: statusValue?.value || "",
      search: searchValue || "",
    }));
  }, [gymValue, statusValue]);

  // Update filters when pagination settings change
  useEffect(() => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      page: isPage + 1,
      limit: pageLimit,
    }));
  }, [isPage, pageLimit]);

  // When search value length is 0, reset search filter
  useEffect(() => {
    setIsPage(0);
    if (searchValue.length === 0) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        search: "",
      }));
    }
  }, [searchValue]);

  const handleEdit = (row) => {
    setIsEdit(true);
    setModalOpen(true);
    setInitialValue(row);
  };

  return (
    <Container className="bg-cloud-k px-50px" fluid>
      <Modal
        isOpen={modalOpen}
        onRequestClose={onCloseModalvalues}
        contentLabel="Trainer Modal"
        ariaHideApp={false}
      >
        <TrainerEdit
          getTrainerData={getTrainerData}
          closeModal={onCloseModalvalues}
          initialValues={initialValue}
          token={userInfoData?.token}
          isEdit={isEdit}
          userInfoData={userInfoData}
        />
      </Modal>

      {/* <h2 className="titleHead">All Trainers</h2> */}

      <Row>
        <Col>
          <CommonStructured
            pageHeading={"All Trainers"}
            // createBtnTxt={"All Trainers"}
            // onClickCreateBtn={handleAdd}
            isReload={() => getTrainerData()}
          />
        </Col>
      </Row>

      <br />
      <div className="cmnFilterStructureContainer ptTrackContainer">
        <div className="filterblock gridSpanTwo">
          <div className="filterHeadingNBtn">
            <h5 className="filterHeading">All Filters</h5>
            <div
              className="flex-k"
              style={{
                gap: "5px",
              }}
            >
              <div className="csvDownloadSection">
                <ExportCSVButton trainerData={trainerData} />
              </div>
              <Button variant="outline-danger" onClick={handleReset}>
                Reset Filter
              </Button>
            </div>
          </div>

          <div className="filterblock grid__three">
            <div
              className={`inputCommonWrapper flexSpacebetween searchBarContainer `}
            >
              <input
                type="search"
                className="input"
                placeholder="Search by mobile, name"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
              <button type="button" className="button" onClick={onClickSearch}>
                search
                <SearchIcon />
              </button>
            </div>

            <div className={`commonWrapper dropdownCommonWrapper `}>
              <SelectDropdownLabel
                options={gymData?.length > 0 ? gymData : []}
                selectedOption={gymValue}
                setSelectedOption={handleGymChange}
                name="Select Gym"
              />
            </div>

            <div className={`commonWrapper dropdownCommonWrapper `}>
              <SelectDropdownLabel
                options={statuses}
                selectedOption={statusValue}
                setSelectedOption={handleStatusChange}
                name="Status"
              />
            </div>
          </div>
        </div>
      </div>
      <br />

      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableColumns={trainerTbColumns(handleEdit, userInfoData)}
            tableData={trainerData?.data}
            tablePagination={trainerData?.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            setPageLimit={setPageLimit}
            pageLimit={pageLimit}
          />
        )}
      </div>
    </Container>
  );
};

export default Trainers;
